/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WizardPlanAssignmentDto
 */
export interface WizardPlanAssignmentDto {
    /**
     * All asset ids to assign
     * @type {Array<string>}
     * @memberof WizardPlanAssignmentDto
     */
    assetIds: Array<string>;
    /**
     * Subset of assetIds confirmed by the caller to replace their current active plan
     * @type {Array<string>}
     * @memberof WizardPlanAssignmentDto
     */
    replaceAssetIds?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof WizardPlanAssignmentDto
     */
    startDate: Date;
}

/**
 * Check if a given object implements the WizardPlanAssignmentDto interface.
 */
export function instanceOfWizardPlanAssignmentDto(value: object): value is WizardPlanAssignmentDto {
    if (!('assetIds' in value) || value['assetIds'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    return true;
}

export function WizardPlanAssignmentDtoFromJSON(json: any): WizardPlanAssignmentDto {
    return WizardPlanAssignmentDtoFromJSONTyped(json, false);
}

export function WizardPlanAssignmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WizardPlanAssignmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetIds': json['assetIds'],
        'replaceAssetIds': json['replaceAssetIds'] == null ? undefined : json['replaceAssetIds'],
        'startDate': (new Date(json['startDate'])),
    };
}

export function WizardPlanAssignmentDtoToJSON(json: any): WizardPlanAssignmentDto {
    return WizardPlanAssignmentDtoToJSONTyped(json, false);
}

export function WizardPlanAssignmentDtoToJSONTyped(value?: WizardPlanAssignmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetIds': value['assetIds'],
        'replaceAssetIds': value['replaceAssetIds'],
        'startDate': value['startDate'].toISOString().substring(0,10),
    };
}

